import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "icon", "text"]
  
  static values = {
    subscribeUrl: String,
    unsubscribeUrl: String,
    isSubscribed: Boolean,
    isCreator: Boolean,
    forumTopicId: Number,
    discussionId: Number
  }

  connect() {
    this.updateButtonState()
  }

  async toggle(event) {
    event.preventDefault()
    
    if (this.isCreatorValue && this.isSubscribedValue) {
      return
    }
    
    const url = this.isSubscribedValue ? this.unsubscribeUrlValue : this.subscribeUrlValue
    const method = this.isSubscribedValue ? "DELETE" : "POST"
    
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })

      if (response.ok) {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('text/vnd.turbo-stream.html')) {
          const html = await response.text()
          Turbo.renderStreamMessage(html)
        } else {
          this.isSubscribedValue = !this.isSubscribedValue
          this.updateButtonState()
        }
      }
    } catch (error) {
      console.error('Erreur lors du toggle d\'abonnement:', error)
    }
  }

  updateButtonState() {
    if (this.hasButtonTarget) {
      const button = this.buttonTarget
      
      if (this.isCreatorValue && this.isSubscribedValue) {
        button.disabled = true
        button.classList.add('cursor-not-allowed', 'opacity-75')
      } else {
        button.disabled = false
        button.classList.remove('cursor-not-allowed', 'opacity-75')
      }
      
      if (this.isSubscribedValue) {
        button.classList.remove('bg-indigo-100', 'text-indigo-700', 'hover:bg-indigo-200')
        button.classList.add('bg-white', 'text-gray-700', 'hover:bg-gray-50', 'border-gray-300')
      } else {
        button.classList.remove('bg-white', 'text-gray-700', 'hover:bg-gray-50', 'border-gray-300')
        button.classList.add('bg-indigo-100', 'text-indigo-700', 'hover:bg-indigo-200')
      }
    }

    if (this.hasIconTarget) {
      const iconHtml = this.isSubscribedValue 
        ? `<svg class="h-4 w-4 mr-1.5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
            <path d="M3 3.5a.5.5 0 00-.5.5v11.707l2-2V4a.5.5 0 00-.5-.5z" fill="currentColor" style="opacity: 0.5" />
            <path d="M17 3.5a.5.5 0 00-.5.5v9.293l2 2V4a.5.5 0 00-.5-.5z" fill="currentColor" style="opacity: 0.5" />
          </svg>`
        : `<svg class="h-4 w-4 mr-1.5 text-indigo-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
          </svg>`;
      
      this.iconTarget.innerHTML = iconHtml
    }

    if (this.hasTextTarget) {
      const text = this.isCreatorValue && this.isSubscribedValue
        ? "Abonné (créateur)"
        : this.isSubscribedValue
          ? "Désabonner"
          : "S'abonner";
          
      this.textTarget.textContent = text
    }
  }
}